<template>
  <img
    v-if="company && company.logo && company.logo_url"
    class="h-12 w-auto max-w-[200px]"
    @error="company.logo = false"
    style="object-fit: scale-down; min-height: 100%"
    :src="company.logo_url"
    :alt="companyLogo"
  />
  <span
    v-else-if="company && company.logo"
    class="flex items-center h-8 text-gray-900 ml-2"
    >{{ companyLogo }}</span
  >

  <span
    v-else
    class="flex items-center ml-2"
  >
    <img
      class="h-6 w-auto logo"
      :src="'/images/black_logo.png'"
      alt=""
    />
  </span>
</template>
<script>
export default {
  name: "PortalBillingCompanyLogo",
  data() {
    return {
      company: window.FinancialCents.company,
    }
  },
  computed: {
    companyLogo() {
      if (!this.company || !this.company.logo) {
        return "FinancialCents"
      }
      const name = this.company.name
      if (name.length <= 39) {
        return name
      }
      return name.substring(0, 39) + "..."
    },
  },
}
</script>
